export const betaFeature = {
  hopFilter: true,
};
export const hasAccess = (featureAccess, user) =>
  featureAccess && user.beta_tester;
